import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToolbarButton } from 'src/app/models/toolbar-button/toolbar-button';
import { ByobBlueprintSummaryComponent } from './byob-blueprint-summary.component';

const routes: Routes = [{
  path: '',
  component: ByobBlueprintSummaryComponent,
  data: {
    activeLink: ToolbarButton.CATALOGUE
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ByobBlueprintSummarRoutingModule { }
